var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-controls" }, [
    _c("div", { staticClass: "c-videocontrols" }, [
      _c("button", { on: { click: _vm.play } }, [
        _c("svg", { staticClass: "icon icon_play" }, [
          _c("use", { attrs: { "xlink:href": "#icon_play" } })
        ])
      ]),
      _vm._v(" "),
      _c("button", { on: { click: _vm.pause } }, [
        _c("svg", { staticClass: "icon icon_pause" }, [
          _c("use", { attrs: { "xlink:href": "#icon_pause" } })
        ])
      ]),
      _vm._v(" "),
      _c("button", { on: { click: _vm.stop } }, [
        _c("svg", { staticClass: "icon icon_stop" }, [
          _c("use", { attrs: { "xlink:href": "#icon_stop" } })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }